import { useThree } from '@react-three/fiber'
import { useContext, useEffect } from 'react'
import { ScenesContext } from '../../b.providers/ScenesProvider/SceneProvider'
import * as Events from '../../b.providers/EventsProvider/EventsProvider'
import fadeIn from './scripts/fadeIn'
import fadeOut from './scripts/fadeOut'
import { EVENTS, TransitionConfig } from './types'

const defaultConfigValues = {
  duration: 500,
  color: 0x000000,
}

const useFadeScenes = (config?: TransitionConfig) => {
  const { camera, scene } = useThree()
  const { duration, color } = config || defaultConfigValues
  const { setCurrentSceneIdx } = useContext(ScenesContext)

  const cameraFadeIn = async () => {
    await fadeIn({ camera, scene, duration, color })
    Events.dispatch(EVENTS.FADE_OUT_COMPLETED, null)
  }

  useEffect(() => {
    cameraFadeIn()
  }, [])

  const navigateTo = async (idx: number) => {
    await fadeOut({ camera, scene, duration, color })
    setCurrentSceneIdx(idx)
  }

  return navigateTo
}

export default useFadeScenes
